import React, { useEffect, useState, useRef } from "react";
import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";
import {
  Button,
  Divider,
  Form,
  Input,
  Modal,
  Select,
  Space,
  Switch,
} from "antd";

import { Option } from "antd/es/mentions";
import { ModalPortal } from "../ModalPortal";
import { countries } from "./phoneCountries";

export const FormScripts = ({
  scriptsList = [],
  setScriptsList,
  handleSubmitScripts,
}) => {
  const selectRef = useRef(null);
  const codeAreaRef = useRef(null);
  const phoneNumberRef = useRef(null);
  //const firstRender = useRef(true)
  const [showPortalModal, setShowPortalModal] = useState(false);
  const [confirmAction, setConfirmAction] = useState(false);
  const [listaLocal, setListaLocal] = useState([]);
  const [isDataModified, setIsDataModified] = useState(false);

  // const getModalConfirmation = new Promise((resolve, reject) => {
  //   setConfirmAction(false)
  //   resolve(true)
  // })

  const tipoScript = ["texto", "url", "whatsapp","elevenlabs"];

  const targetScript = ["head", "body"];

  const [form] = Form.useForm();

  useEffect(() => {
    console.log("%c scriptsList en FormScripts: ", "color: blue", scriptsList);
    form.setFieldsValue({
      listadoScripts: scriptsList,
    });
  }, [scriptsList]);

  // const onFinish = (values) => {
  //   // setShowPortalModal(true);
  //   setListaLocal([...values.listadoEnlaces]);

  //   setTimeout(() => {
  //           console.log("%c Estado de Lista Local en FormEnlances: ","color: green", listaLocal);
  //   }, 4000);

  //   //handleSubmitEnlaces(values.listadoEnlaces);

  //   if(confirmAction) {

  //   }
  // };

  // const handleOnChangeData = () => {
  //   setIsDataModified(true)
  // }

  const ScriptField = ({ name, remove, key, ...restField }) => {
    const tipoValue = Form.useWatch(["listadoScripts", name, "tipo"], form);
    //cada tipo muestra solo sus datos; los demas quedan guardados pero ocultos
    const esTexto = tipoValue === "texto";
    const esUrl = tipoValue === "url";
    const esWhatsapp = tipoValue === "whatsapp";
    const esElevenlabs = tipoValue === "elevenlabs";

    return (
      <Space
        key={key}
        style={{
          backgroundColor: "#071529",
          display: "flex",
          flexDirection: "column",
          marginBottom: 8,
          padding: 10,
          color: "white",
          alignItems: "center",
        }}
        align="baseline"
      >
        <Divider style={{ color: "white" }} orientation="left" plain>
          <b>
            <u>Datos de Script:</u>
          </b>
        </Divider>
        <Form.Item
          {...restField}
          initialValue=""
          name={[name, "descripcion"]}
          rules={[
            {
              transform: (value) => value.trim() || "sin titulo",
            },
          ]}
          label={<span style={{ color: "white" }}>Descripción</span>}
        >
          <Input placeholder="Descripción o titulo" onChange={(value) => {}} />
        </Form.Item>
        <Form.Item
          {...restField}
          name={[name, "tipo"]}
          rules={[
            {
              required: true,
              message: "el tipo es obligatorio",
            },
          ]}
          label={<span style={{ color: "white" }}>Tipo</span>}
        >
          <Select
            placeholder="tipo de script"
            // onChange={handleOnChangeData}
            //allowClear
          >
            {tipoScript.map((tipo, index) => (
              <Option key={index} value={tipo}>
                {tipo}
              </Option>
            ))}
          </Select>
        </Form.Item>
        {(esTexto || esUrl) && (
        <Form.Item
          {...restField}
          name={[name, "target"]}
          rules={[
            {
              required: tipoValue !== "whatsapp" && tipoValue !== "elevenlabs",
              message: "Seleccione ubicación (head o body)",
            },
          ]}
          label={<span style={{ color: "white" }}>Target</span>}
        >
          <Select
            placeholder="ubicación"
            disabled={tipoValue === "whatsapp" || tipoValue === "elevenlabs"}
            // onChange={handleOnChangeData}
            //allowClear
          >
            {targetScript.map((target, index) => (
              <Option key={index} value={target}>
                {target}
              </Option>
            ))}
          </Select>
        </Form.Item>
        )}

        <Form.Item
          {...restField}
          name={[name, "habilitado"]}
          valuePropName="checked"
          initialValue={true}
          label={<span style={{ color: "white" }}>Habilitado</span>}
        >
          <Switch />
          {/* <Input onChange={handleOnChangeData} placeholder="url del script" /> */}
        </Form.Item>

        {(esTexto || esElevenlabs) && (
        <Form.Item
          {...restField}
          initialValue=""
          name={[name, "texto"]}
          rules={[
            {
              required: tipoValue === "texto" || tipoValue === "elevenlabs",
              message: tipoValue === "elevenlabs" 
                ? "El código HTML de ElevenLabs es obligatorio" 
                : "el texto es obligatorio",
            },
          ]}
          label={
            <span style={{ color: "white" }}>
              {tipoValue === "elevenlabs" 
                ? "Código HTML de ElevenLabs" 
                : "Texto de Script"}
            </span>
          }
        >
          <Input.TextArea
            rows={tipoValue === "elevenlabs" ? 6 : 4}
            disabled={tipoValue !== "texto" && tipoValue !== "elevenlabs"}
            placeholder={
              tipoValue === "elevenlabs"
                ? "Pegue aquí el código completo de ElevenLabs (ej: <elevenlabs-convai agent-id='...'></elevenlabs-convai><script src='...'></script>)"
                : "texto del script"
            }
            onChange={(value) => {
              // Para ElevenLabs, validamos que contenga las etiquetas necesarias
              if (tipoValue === "elevenlabs") {
                const hasElevenlabsTag = /<elevenlabs-convai[^>]*>/i.test(value.target.value);
                const hasScriptTag = /<script[^>]*src[^>]*elevenlabs[^>]*>/i.test(value.target.value);
                
                if (value.target.value && (!hasElevenlabsTag || !hasScriptTag)) {
                  Modal.warning({
                    title: "Código ElevenLabs Incompleto",
                    content: "Asegúrese de incluir tanto la etiqueta <elevenlabs-convai> como el <script> de ElevenLabs.",
                  });
                }
              } else if (tipoValue === "texto") {
                // Validación original para texto normal
                if (/<[^>]*>/g.test(value.target.value)) {
                  Modal.warning({
                    title: "Atención",
                    content: "No se recomienda usar etiquetas HTML. Por favor, ingrese solo el texto del script.",
                  });
                  form.setFieldValue(["listadoScripts", name, "texto"], "");
                }
              }
            }}
          />
        </Form.Item>
        )}

        {esUrl && (
        <Form.Item
          {...restField}
          initialValue=""
          name={[name, "url"]}
          enabled={restField.tipo === "url"}
          rules={[
            {
              required: tipoValue === "url",
              message: "la url es obligatoria",
            },
          ]}
          label={<span style={{ color: "white" }}>Url de Script</span>}
        >
          <Input
            disabled={tipoValue !== "url"}
            placeholder="url del script"
            onChange={(value) => {
              const urlPattern =
                /^(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})([/\w .-]*)*\/?$/;
              if (
                !urlPattern.test(value.target.value) &&
                value.target.value !== ""
              ) {
                Modal.warning({
                  title: "URL Inválida",
                  content:
                    "Por favor, ingrese una URL válida (ejemplo: https://ejemplo.com/script.js)",
                });
                form.setFieldValue(["listadoScripts", name, "url"], "");
              }
            }}
          />
        </Form.Item>
        )}

        {esWhatsapp && (
        <>
        <Space.Compact direction="vertical" style={{ width: "100%" }}>
          {/* Selector de País */}
          <Form.Item
            // name={[name, "telefono", "countryCode"]}                        
            noStyle            
          >
            <Select
              allowClear
              ref={selectRef}
              disabled={tipoValue !== "whatsapp"}
              style={{ width: "95%", margin: "10px 0px" }}
              showSearch
              placeholder="Elija país"
              defaultValue={undefined}
              onSelect={(value, option) => {
                let dato = value;
                if(option && option["data-country"] === "Argentina" ) {
                  dato = `${value}9`
                }; // Asignar el código de país Argentina
                form.setFieldValue(
                  ['listadoScripts', name, 'telefono'],
                  `${dato}${form.getFieldValue(['listadoScripts', name, 'telefono']) || ''}`
                )
              }}
              
            >
              {countries.map((country) => (
                <Option
                  key={country.code}
                  value={country.code}
                  label={country.name}
                  data-country={country.name}
                >
                  <Space>
                    <span>{country.flag}</span>
                    <span>{country.code}</span>
                    <span>{country.name}</span>
                  </Space>
                </Option>
              ))}
            </Select>
          </Form.Item>

          {/* Código de área */}
          <Form.Item
            //  name={[name, "telefono", "areaCode"]}
            noStyle
          >
            <Input
              allowClear
              ref={codeAreaRef}
              disabled={tipoValue !== "whatsapp"}
              style={{ width: "95%", margin: "10px 0px" }}
              placeholder="Área"
              maxLength={4}
              onBlur={(e) => {
                const areaCodePattern = /^\d{1,4}$/;
                if (areaCodePattern.test(e.target.value) || e.target.value === "") {                  
                  form.setFieldValue(["listadoScripts", name, "telefono"], 
                     `${form.getFieldValue(['listadoScripts', name, 'telefono']) || ''}${e.target.value}` // Mantener el número de teléfono existente                     
                  );
                  
                }else{
                  Modal.warning({
                    title: "Código de Área Inválido",
                    content:
                      "Por favor, ingrese un código de área válido (1-4 dígitos)",
                  });
                }
              }              }
              
            />
          </Form.Item>

          {/* Número de teléfono */}
          <Form.Item
            //  name={[name, "telefono", "number"]}
            noStyle
          >
            <Input
              allowClear
              disabled={tipoValue !== "whatsapp"}
              placeholder="Número"
              style={{ width: "95%", margin: "10px 0px" }}
              maxLength={10}
              onBlur={(e) => {
                const phonePattern = /^\d+$/;
                if (phonePattern.test(e.target.value) || e.target.value === "") {                  
                  form.setFieldValue(["listadoScripts", name, "telefono"], 
                     `${form.getFieldValue(['listadoScripts', name, 'telefono']) || ''}${e.target.value}` // Mantener el número de teléfono existente
                  );
                }else{
                  Modal.warning({
                    title: "numero inválido",
                    content:
                      "Por favor, ingrese un número de teléfono válido (solo dígitos)",
                  });
                }
              }              }
            />
          </Form.Item>
        </Space.Compact>

        <Form.Item
          {...restField}
          initialValue=""
          name={[name, "telefono"]}
          enabled={restField.tipo === "whatsapp"}
          rules={[
            {
              required: tipoValue === "whatsapp",
              message: "El número de teléfono es obligatorio",
            },
          ]}
          label={<span style={{ color: "white" }}>Telefono</span>}
        >
          <Input
            allowClear
            disabled={tipoValue !== "whatsapp"}
            placeholder="Teléfono (ej: +1234567890)"
             value={form.getFieldValue(['listadoScripts', name, 'telefono'])}
            onBlur={(e) => {
              const phonePattern = /^\+?[1-9]\d{1,14}$/;
              if (!phonePattern.test(e.target.value) && e.target.value !== "") {
                Modal.warning({
                  title: "Celular Inválido",
                  content:
                    "Por favor, ingrese un número de teléfono válido (ejemplo: +1234567890)",
                });
                form.setFieldValue(["listadoScripts", name, "telefono"], "");
              }
            }}
            onChange={(e) => {
              
            }}
          />
        </Form.Item>
        <Form.Item
          {...restField}
          initialValue=""
          name={[name, "mensaje"]}
          enabled={restField.tipo === "whatsapp"}
          // rules={[
          //   {
          //     required: tipoValue === "whatsapp",
          //     message: "El número de teléfono es obligatorio",
          //   },
          // ]}
          label={<span style={{ color: "white" }}>Mensaje</span>}
        >
          <Input
            disabled={tipoValue !== "whatsapp"}
            placeholder="mensaje (ej: Hola, ¿cómo estás?)"
            // onBlur={(e) => {
            //     const phonePattern = /^\+?[1-9]\d{1,14}$/;
            //   if (!phonePattern.test(e.target.value) && e.target.value !== "") {
            //     Modal.warning({
            //       title: "Celular Inválido",
            //       content: "Por favor, ingrese un número de teléfono válido (ejemplo: +1234567890)",
            //     });
            //     form.setFieldValue(['listadoScripts', name, 'telefono'], '');
            //   }
            // }
            //   }
          />
        </Form.Item>
        </>
        )}

        <MinusCircleOutlined
          onClick={() => remove(name)}
          //onClick={handleOnClick("remove", add, remove, name)}
        />
      </Space>
    );
  };

  return (
    <>
      {/* <Title level={5}>Formulario de Enlaces</Title> */}
      <Form
        form={form}
        theme="dark"
        name="scripts-form"
        onFinish={async (values) => {
          console.log("%c Valores del formulario: ", "color: teal", values);
          // Actualizar el estado local
          setListaLocal([...values.listadoScripts]);
          // Enviar los datos al componente padre
          setScriptsList([...values.listadoScripts]);
          await handleSubmitScripts(values.listadoScripts);
          // Resetear el flag de modificación
          setIsDataModified(false);
        }}
        initialValues={{
          listadoScripts: scriptsList,
        }}
        onValuesChange={(changedValues, allValues) => {
          setIsDataModified(true);
          if (changedValues.listadoEnlaces) {
            setScriptsList(changedValues.listadoEnlaces);
          }
        }}
        style={{
          maxWidth: 600,
        }}
        autoComplete="off"
        layout="vertical"
      >
        <Form.List name="listadoScripts">
          {(fields, { add, remove }) => (
            <>
              {fields.map(({ key, name, ...restField }) => {
                return (
                  <ScriptField
                    key={key}
                    name={name}
                    remove={remove}
                    {...restField}
                  />
                );
              })}
              <Form.Item>
                <Button
                  type="dashed"
                  //onClick={handleOnClick("add", add, remove)}
                  onClick={() => add()}
                  block
                  icon={<PlusOutlined />}
                >
                  Agregar mensajería
                </Button>
              </Form.Item>
            </>
          )}
          </Form.List>
        <Form.Item>
          <Button disabled={!isDataModified} type="primary" htmlType="submit">
            Guardar Cambios
          </Button>
        </Form.Item>
      </Form>
      <ModalPortal
        showModal={showPortalModal}
        setShowModal={setShowPortalModal}
        setConfirmAction={setConfirmAction}
      />
    </>
  );
};
